/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Table } from "antd";
import PageHeading from "../../components/common/PageHeading";
import RightBar from "../../components/common/RightBar";

import "./PropertiesPage.css";

import RightBarMethod from "../../components/common/RightBar/RightBarMethod";
import Footer from "../../components/common/Footer";

import { propertyData } from "../../data/properties";
import { collection, doc, getDocs, query, where } from "firebase/firestore";

import { auth, db } from "../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

// label, key, icon, children,url
const PropertiesRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("New Property", "1", "", "", "/properties/new"),
    RightBarMethod(
      "New Property Group",
      "2",
      "",
      "",
      "/generalsettings/new-property-groups"
    ),
    RightBarMethod(
      "Manage Lockboxes",
      "3",
      "",
      "",
      "/leasing/guest-cards/manage-lockboxes"
    ),
    RightBarMethod("New Associations", "4", "", "", "/association/new"),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Property Directory", "5", "", "", "/"),
      RightBarMethod("Unit Directory", "6", "", "", "/"),
      RightBarMethod("Rent Roll", "7", "", "", "/"),
      RightBarMethod("Unit Vacancy Detail", "8", "", "", "/"),
      RightBarMethod("General Ledger", "9", "", "", "/"),
    ]
  ),

  RightBarMethod(" STATEMENTS", "t3", <i className="fa-solid fa-file"></i>, [
    RightBarMethod("Bulk Update Statement Settings", "10", "", "", "/"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("View, Edit & Add Properties", "11", "", "", "/"),
      RightBarMethod("Managing Property Groups", "12", "", "", "/"),
    ]
  ),
];

function PropertiesPage() {
  const [user, loading] = useAuthState(auth);
  // const [isShowHiddenData, setIsShowHiddenData] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const navigate = useNavigate();

  const fetchCompanyName = async () => {
    setIsLoading(true); // start loading

    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    } finally {
      setIsLoading(false); // stop loading
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const handleRowClick = (id) => {
    navigate(`/property-tabs/property/${id}`);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      render: (name, record) => <span className="onclick-text">{name}</span>,
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: true,
    },
    {
      title: "Units",
      dataIndex: "units",
    },
    {
      title: "Vacant",
      dataIndex: "vacant",
    },
    {
      title: "Owners",
      dataIndex: "owners",
    },
  ];

  const [propertiesList, setPropertiesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // const ShowOrHideData = () => {
  //   if (isShowHiddenData) {
  //     setIsShowHiddenData(false);
  //   } else {
  //     setIsShowHiddenData(true);
  //   }
  // };

  const fetchProperty = async () => {
    setIsLoading(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertiesRef = collection(companyDocRef, "properties");
      const querySnapshot = await getDocs(propertiesRef);
      const fetchedProperties = [];

      querySnapshot.forEach((doc) => {
        const propertyData = doc.data();
        const propertyWithId = { id: doc.id, ...propertyData };
        fetchedProperties.push(propertyWithId);
      });

      setPropertiesList(fetchedProperties);
    } catch (err) {
      console.error(err);
      // alert("An error occured while fetching user data");
    } finally {
      setIsLoading(false); // stop loading
    }
  };
  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchProperty();
  }, [companyName, isCompanyNameFetched]);

  const data = [];
  propertiesList.map((item) => {
    const selectedData = {
      key: item.id,
      name: item.propertyNameAddress.propertyName,
      type: item.propertyNameAddress.propertyType,
      units: 1,
      vacant: " ",
      owners: " ",
    }; // Select only the id and name properties from each object in the original array
    data.push(selectedData);
  });

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Properties" />
          <p>Click on any row to view property information.</p>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}  // Set loading prop
            onRow={(record, rowIndex) => {
              return {
                onClick: () => handleRowClick(record.key),
                className: "clickable-row",
                // Add any other props you want to pass to the row here
              };
            }}
          />
          {/* <button className="showHiddenProperties" onClick={ShowOrHideData}>
            {isShowHiddenData ? "Hide" : "Show"} Hidden Properties
          </button> */}
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PropertiesRightBar} />
      </div>
    </>
  );
}

export default PropertiesPage;
